"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coalesceMeasure = void 0;
/**
 * @summary Finds the first `Measure` that has a non-null value and returns it.
 *
 * Finds the first `Measure` that has a non-null value and returns it. If all values are null, the last
 * `Measure` is returned. If no values are given, throws a `TypeError`.
 *
 * @param {NullableMeasure[]} values
 * @returns {NullableMeasure}
 * @throws {TypeError}
 *
 * @example
 * const production = coalesceMeasure(getFromForecast(), getFromDefaults());
 */
function coalesceMeasure(...values) {
    if (values.length === 0) {
        throw new TypeError('Cannot determine non-null Measure in empty array.');
    }
    for (const value of values) {
        if (value.value != null) {
            return value;
        }
    }
    return values[values.length - 1];
}
exports.coalesceMeasure = coalesceMeasure;
